var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"van-fade"}},[_c('div',{staticClass:"scrolltop",class:{ open: _vm.visible },style:(_vm.set_bg_style()),on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[_c('van-icon',{attrs:{"color":_vm.color,"size":_vm.size,"name":"back-top"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }